// extracted by mini-css-extract-plugin
module.exports = {"header":"MXZAf","logo":"G49-N","group":"iH4jS","group-info":"_7vjS1","group-info-hr":"_4Me0N","groups":"UqOTf","group-description":"VxPpF","group-items":"yvkHV","grid":"EWRS5"};